function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { CloseOutlined } from '@ant-design/icons';
import { Drawer, Space } from 'antd';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
var HeaderDrawer = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    button = props.button,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'left' : _props$placement;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useImperativeHandle(ref, function () {
    return {
      closeModal: function closeModal() {
        setVisible(false);
      }
    };
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setVisible(true);
    }
  }, button), /*#__PURE__*/React.createElement(Drawer, {
    className: "dr-nav-drawer",
    width: 300,
    title: /*#__PURE__*/React.createElement(Space, {
      size: 12
    }, /*#__PURE__*/React.createElement(CloseOutlined, {
      onClick: function onClick() {
        setVisible(false);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "dr-nav-logo"
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://hwobs.fanruan.com/ui/digit-fe/header/fine_logo_dynamic.gif",
      alt: "fine_logo"
    }))),
    placement: placement,
    closable: false,
    onClose: function onClose() {
      setVisible(false);
    },
    open: visible,
    key: "test"
  }, children));
});
export default HeaderDrawer;